import { delayedEvent } from '../utils/eventUtils';
import { retrieveAuthTokens } from '../utils/next/auth.utils';
import WebWorker from './workerSetup';

const INTERVAL_SECONDS = 60;

const versionWorker = () => {
  onmessage = (event) => {
    const { origin } = event.target;

    const options = {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${event.data}`,
      },
    };

    fetch(`${origin}/api/console-version`, options)
      .then((response) => response.json())
      .then((data) => {
        postMessage(data);
      })
      .catch(console.error.bind(console));
  };
};

const VersionLayer = {
  init() {
    const worker = new WebWorker(versionWorker);
    const tokenInterval = setInterval(() => {
      const { accessToken } = retrieveAuthTokens();

      if (!accessToken) {
        worker.terminate();
        clearInterval(tokenInterval);
        return;
      }

      worker.postMessage(accessToken);
    }, INTERVAL_SECONDS * 1000);

    worker.onmessage = (event) => {
      const { v } = event.data;
      if (v === 'SERVER_DOWN') {
        delayedEvent('server-down', v);
      } else {
        delayedEvent('version-changed', 100, v);
      }
    };
  },
};

export default VersionLayer;
